import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-259eda4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-row-reverse" }
const _hoisted_2 = {
  key: 1,
  class: "pending-label"
}
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "mb-24 d-flex justify-content-center align-items-center" }
const _hoisted_5 = { class: "period" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "period-separator" }, null, -1))
const _hoisted_7 = { class: "period" }
const _hoisted_8 = { class: "info-box" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator" }, null, -1))
const _hoisted_10 = { class: "row-info d-flex justify-content-between" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "new-partners-label" }, "New Partners", -1))
const _hoisted_12 = { class: "row-info d-flex justify-content-between" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "macd-label" }, "MACD", -1))
const _hoisted_14 = { class: "row-info d-flex justify-content-between" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "dot dot-moved" }, " "),
  /*#__PURE__*/_createElementVNode("div", null, "Moved")
], -1))
const _hoisted_16 = { class: "row-info d-flex justify-content-between" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "dot dot-add" }, " "),
  /*#__PURE__*/_createElementVNode("div", null, "Add")
], -1))
const _hoisted_18 = { class: "row-info d-flex justify-content-between" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "dot dot-change" }, " "),
  /*#__PURE__*/_createElementVNode("div", null, "Change")
], -1))
const _hoisted_20 = { class: "row-info d-flex justify-content-between" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "dot dot-disconnect" }, " "),
  /*#__PURE__*/_createElementVNode("div", null, "Disconnect")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DoneSvg = _resolveComponent("DoneSvg")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
      'quadrant': true,
      'quadrant-completed': _ctx.quadrant.is_completed,
    })
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.quadrant.is_completed)
        ? (_openBlock(), _createBlock(_component_DoneSvg, {
            key: 0,
            class: "done-svg"
          }))
        : (_openBlock(), _createElementBlock("p", _hoisted_2, "Pending"))
    ]),
    _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.title), 1),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.periodFrom), 1),
      _createTextVNode(),
      _hoisted_6,
      _createTextVNode(),
      _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.periodTo), 1)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("div", null, _toDisplayString(_ctx.quadrant.new_partners), 1)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("div", null, _toDisplayString(_ctx.quadrant.macd.add + _ctx.quadrant.macd.move + _ctx.quadrant.macd.change + _ctx.quadrant.macd.disconnect), 1)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createElementVNode("div", null, _toDisplayString(_ctx.quadrant.macd.move), 1)
      ]),
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _createElementVNode("div", null, _toDisplayString(_ctx.quadrant.macd.add), 1)
      ]),
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _createElementVNode("div", null, _toDisplayString(_ctx.quadrant.macd.change), 1)
      ]),
      _createElementVNode("div", _hoisted_20, [
        _hoisted_21,
        _createElementVNode("div", null, _toDisplayString(_ctx.quadrant.macd.disconnect), 1)
      ])
    ])
  ], 2))
}